var React = require('react');

function ToolTerraform (props) {
    return React.createElement("svg",props,[React.createElement("g",{"className":"fill-background--medium","key":0},[React.createElement("polygon",{"points":"9.1,11.6 4.5,8.9 4.5,3.6 9.1,6.3 ","key":0}),React.createElement("polygon",{"points":"14.3,14.7 9.7,12 9.7,6.7 14.3,9.3 ","key":1}),React.createElement("polygon",{"points":"14.3,20.9 9.7,18.2 9.7,12.8 14.3,15.5 ","key":2})]),React.createElement("polygon",{"className":"fill-background","points":"14.9,14.8 19.5,12.1 19.5,6.8 14.9,9.4 ","key":1})]);
}

ToolTerraform.defaultProps = {"version":"1.0","width":"48","height":"48","viewBox":"0 0 24 24"};

module.exports = ToolTerraform;

ToolTerraform.default = ToolTerraform;
